module.exports = __webpack_public_path__ + "assets/clone.e4845cc00fc679c2597473f5b633ae8f.svg";